import React, { Component } from "react";
import moment from "moment";
import API, { URL_PATH } from "../../services/API";
import Redux from "../../common/Redux";
class GalleryScreen extends Component {
  constructor(props) {
    super(props);
    this.state = { test: 1 };
  }
  saveData = async (e) => {
    e.preventDefault();
    console.log("create gallery");
    const formData = new FormData(e.target);
    //console.table(formData);
    const headers = {
      "Content-Type": "multipart/form-data",
    };

    const data = await API(
      this,
      "post",
      URL_PATH.createGallery,
      formData,
      headers
    );

    alert({
      title: "Success",
      text: "Gallery created successfully",
      icon: "success",
    });
  };
  render() {
    return (
      <div className="container">
        <h1>create gallery</h1>
        <form className="row" onSubmit={(e) => this.saveData(e)}>
          <div className="col-md-6">
            <div className="form-group">
              <label>Title</label>
              <input
                type="text"
                className="form-control"
                // value={name}
                name="title"
                id="name"
                required
              />
            </div>
            <div className="form-group mt-2">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckDefault"
              />
              <label style={{ marginLeft: 10 }}> Active</label>
            </div>
            <div className="form-group mt-2">
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default Redux(GalleryScreen);
